<template>
  <el-dialog
    :visible.sync="showModal"
    center
    class="login-modal"
    @closed="emitEvent"
  >
    <el-row
      type="flex"
      justify="center"
    >
      <el-col
        :span="24"
        justify="center"
        align="middle">
        <p>Login to your Luminary account to save shows and start a playlist.</p>
        <router-link
          class="el-button btn-transparent m-t"
          aria-label="Log in"
          to="../signin">Log In</router-link>
        <router-link
          class="el-button btn-transparent m-t"
          aria-label="Register"
          to="../signup">Register</router-link>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  name: 'PremiumContentModal',
  props: {
    show_modal: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      showModal: this.show_modal,
    };
  },
  watch: {
    showModal() {
      return this.show_modal;
    },
  },
  methods: {
    emitEvent() {
      this.$emit('modalClosed');
    },
  },
};
</script>
<style lang="scss" scoped>
.lock-icon {
  width: 80px;
}
</style>
